import { numericFormatter } from "react-number-format";
import { RespuestaSolicitudesPrepagoDto } from "../models/respuestaSolciitudesPrepagoDto";
import { columns } from "../../../dtos/columns";
import AccionesPrepago from "../components/accionesPrepago";

interface IProps {
  controlTabla: any;
  irARecaudarSolicitud: (solicitud: RespuestaSolicitudesPrepagoDto) => void;
  irADesrecaudarSolicitud: (solicitudId: number) => void;
  irARemesarSolicitud: (solicitudId: number) => void;
  isDesactivado?: boolean;
}

export function useColumnSolicitudesLiquidadas({ controlTabla, irARecaudarSolicitud, irADesrecaudarSolicitud, irARemesarSolicitud, isDesactivado}: IProps) {
  const COLUMNS: columns<RespuestaSolicitudesPrepagoDto>[] = [
    {
      name: "Acciones",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.id,
      cell: (row) => <AccionesPrepago estado={row.estado} 
                                      actionLiquidar={() => {}} 
                                      actionRecaudar={() => irARecaudarSolicitud(row)}
                                      actionDesrecaudar={() => irADesrecaudarSolicitud(row.id)}
                                      actionRemesar={() => irARemesarSolicitud(row.id)}
                                      isDesactivado={isDesactivado}
                                    />,
      sortable: true,
      sortField: "id",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha Solicitud",
      selector: (row: RespuestaSolicitudesPrepagoDto) => {
        const fecha = new Date(row.fechaSolicitud!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaSolicitud",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha de pago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => {
        const fecha = new Date(row.fechaPago!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaPago",
      wrap: true,
      export: true,
    },
    {
      name: "Tipo prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.tipo,
      sortable: true,
      sortField: "tipo",
      wrap: true,
      export: true,
    },
    {
      name: "Motivo prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.motivo,
      sortable: true,
      sortField: "motivo",
      wrap: true,
      export: true,
    },
    {
      name: "Modo pago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `${row.modo}`,
      sortable: true,
      sortField: "modo",
      wrap: true,
      export: true,
    },
    {
      name: "Monto de prepago a capital",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.montoPrepagoCapital}` || '',
      cell: (row) => numericFormatter((row.montoPrepagoCapital ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "montoPrepagoCapital",
      wrap: true,
      export: true,
    },
    {
      name: "Comisión de prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.comision}`,
      cell: (row) => numericFormatter((row.comision ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "comision",
      wrap: true,
      export: true,
    },
    {
      name: "Interés devengado",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.interesDevengado}`,
      cell: (row) => numericFormatter((row.interesDevengado ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "interesDevengado",
      wrap: true,
      export: true,
    },
    {
      name: "Seguro mes prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.segurosMes}`,
      cell: (row) => numericFormatter((row.segurosMes ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "segurosMes",
      wrap: true,
      export: true,
    },
    {
      name: "Monto dividendos impagos",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.montoDividendosImpagos}`,
      cell: (row) => numericFormatter((row.montoDividendosImpagos ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "montoDividendosImpagos",
      wrap: true,
      export: true,
    },
    {
      name: "Interes penal dividendos",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.interesPenalDividendos}`,
      cell: (row) => numericFormatter((row.interesPenalDividendos ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "interesPenalDividendos",
      wrap: true,
      export: true,
    },
    {
      name: "Gastos cobranza dividendos",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.gastosCobranzaDividendos}`,
      cell: (row) => numericFormatter((row.gastosCobranzaDividendos ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "gastosCobranzaDividendos",
      wrap: true,
      export: true,
    },
    {
      name: "Total a pagar",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.totalPagar}`,
      cell: (row) => numericFormatter((row.totalPagar ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "totalPagar",
      wrap: true,
      export: true,
    },
    {
      name: "Estado",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `${row.estado}`,
      sortable: true,
      sortField: "estado",
      wrap: true,
      export: true,
    },
  ];

  return { COLUMNS };
}
